import React from 'react';
import { styled } from 'styled-components';
import { HudIcon } from '../Icons/HudIcons';
import { TextTooltip } from '../TextTooltip/TextTooltip';

const ContentContainer = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 12px;

  li {
    display: flex;
    svg {
      position: relative;
      margin-right: 10px;
      top: 1px;
    }
  }
  .endpointMeta {
    display: flex;
    flex-wrap: wrap;
    gap: 1ch;
  }
  .path {
    word-break: break-all;
  }
`;

interface TooltipContentProps {
  methods: string[];
  path: string;
  service: string;
  children?: React.ReactNode;
}

export function EndpointTooltipContent(props: TooltipContentProps) {
  return (
    <ContentContainer>
      <li>
        <HudIcon icon={'webviewMenu.endpoint'} />
        <div className="endpointMeta">
          <span className="methods">
            {props.methods.map((e) => e.toLocaleUpperCase()).join(', ')}
          </span>
          <span className="path">{props.path}</span>
        </div>
      </li>
      <li>
        <HudIcon icon="entities.servicesBlank" /> {props.service}
      </li>
    </ContentContainer>
  );
}

export function EndpointTooltip(props: TooltipContentProps) {
  return (
    <TextTooltip label={<EndpointTooltipContent {...props} />}>
      {props.children}
    </TextTooltip>
  );
}
